import BaseValidator from "./Base";

export default class MaxLengthValidator extends BaseValidator {
    private maxLength: number;

    constructor(name: string, message: string, maxLength: number) {
        super(name, message);
        this.maxLength = maxLength;
    }

    isNotValid(value: any): boolean {
        return value.length > this.maxLength;
    }
}
